var map = {
	"./bg": "./app/webpacker/images/bg.webp",
	"./bg.webp": "./app/webpacker/images/bg.webp",
	"./buddy_blank": "./app/webpacker/images/buddy_blank.png",
	"./buddy_blank.png": "./app/webpacker/images/buddy_blank.png",
	"./buddy_blank_big": "./app/webpacker/images/buddy_blank_big.png",
	"./buddy_blank_big.png": "./app/webpacker/images/buddy_blank_big.png",
	"./cowork-preview": "./app/webpacker/images/cowork-preview.jpg",
	"./cowork-preview.jpg": "./app/webpacker/images/cowork-preview.jpg",
	"./favicon": "./app/webpacker/images/favicon.png",
	"./favicon.png": "./app/webpacker/images/favicon.png",
	"./logo_navbar": "./app/webpacker/images/logo_navbar.png",
	"./logo_navbar.png": "./app/webpacker/images/logo_navbar.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/webpacker/images sync recursive ^\\.\\/.*$";